module.exports = __webpack_public_path__ + "img/company_img11.30e8f3db.jpg";